import * as models from "app/models/requireme";
import { flatten, mapMany, unique, intersectKeys, orderBy, groupBy, pipe, sum, innerJoin, any, firstMap } from "keautils";

/**Un elemento del listado de destinos */
export interface Destino {
    NombreCliente: string;
    Direccion: models.DireccionDTO;
    DireccionCorta: string;
    CantGuias: number;
    CantPaquetes: number;
    CantSobres: number;
    ImportePagar: number;

    IdDireccionCliente: number;

    Visitado: boolean;
    CantRealizadas: number;
    CantIncompletas: number;
    CantGuiasProcesadas: number;
    CantEntregasRealizadas: number;
    EstaIncompleto: boolean;
    MotivoIncompleto: string | undefined;

}

/**Obtiene el listado de destinos listo para ser mostrado */
export function GetDestinoFromState(x: models.ViajeAppIniciado): Destino[] {
    const clientes = x.datos.Clientes;
    const destinosClientes = mapMany(clientes, x => x.Direcciones);
    const contactosClientes = mapMany(destinosClientes, x => x.Contactos);
    const guias = x.datos.Guias;
    const idDestinosGuias = guias.map(x => x.IdDireccionClienteDestino)

    const todasRealizadas = x.model.EntregasRealizadas;
    const todasIncompletas = x.model.EntregasIncompletas;

    //Intersecta los destinos de los clientes con los destinos de las guias y ordenamos por CP
    const destinosClientesFiltrados =
        orderBy(
            intersectKeys(destinosClientes, idDestinosGuias, x => x.IdRegistro),
            x => x.Direccion.CodigoPostal);

    const destinosGuias = pipe(
        guias,
        //Agrupar las guias por destino
        guias => groupBy(guias, x => x.IdDireccionClienteDestino),
        //Por cada grupo, traerse toda la información de ese destino
        grupos => innerJoin(grupos, destinosClientes, (left, right) => left.key == right.IdRegistro).map(x => ({ ...x.left, direccion: x.right })),
        //Traerse la información del cliente:
        grupos => innerJoin(grupos, clientes, (grupo, cliente) => grupo.direccion.IdCliente == cliente.IdRegistro).map(x => ({ ...x.left, cliente: x.right })),

        //Por cada grupo nos traemos cada una de los entregas realizadas e incompletas
        grupos => grupos.map(x => ({
            ...x,
            realizadas: todasRealizadas.filter(relalizada => relalizada.IdDireccionDestino == x.key),
            incompletas: todasIncompletas.filter(inc => inc.IdDireccionDestino == x.key)
        })),
        //Traerse las entregas realizadas e incompletas en ese destino
        //Armar el objeto de destino caso por completo:
        grupos => grupos.map<Destino>(x => ({
            CantGuias: x.items.length,
            CantPaquetes: sum(x.items.map(guia => guia.CantidadPaquetes)),
            CantSobres: sum(x.items.map(guia => guia.CantidadSobres)),
            ImportePagar: sum(x.items.filter(x => x.FletePorCobrar && !x.Pagada).map(x => x.Importes ? x.Importes.Total : 0)),
            Direccion: x.direccion.Direccion,
            DireccionCorta: `${x.direccion.Direccion.Calle} #${x.direccion.Direccion.NoExterior}, CP ${x.direccion.Direccion.CodigoPostal}, col. ${x.direccion.Direccion.NombreColonia}`,
            IdDireccionCliente: x.key,
            NombreCliente: x.cliente.Nombre,
            Visitado: x.realizadas.length > 0 || x.incompletas.length > 0,
            CantRealizadas: x.realizadas.length,
            CantIncompletas: x.incompletas.length,
            CantGuiasProcesadas: sum(x.realizadas.map (y => y.GuiasNoEntregadas.length + y.IdGuiasEntregadas.length)),
            CantEntregasRealizadas: todasRealizadas.filter(y => y.IdDireccionDestino == x.key).length,
            EstaIncompleto: any(todasIncompletas,  y => y.IdDireccionDestino == x.key),
            MotivoIncompleto: firstMap(todasIncompletas, y => y.IdDireccionDestino == x.key, x => x.Motivo)
        }))
        );

    return destinosGuias;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/destinos/model.ts